'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @module PayPalButton
  * A component for rendering a PayPal button
  * @param {string} expoName - the expo name
  * @param {string} expoID - the id of the expo
  * @param {string} showID - the id of the show
  * @param {string} affiliateName (optional) - the name of the affiliate group
  * @param {string} token (optional) - the id of the affilate group
  */
var PayPalButton = function (_Component) {
  _inherits(PayPalButton, _Component);

  /** @constructor
    * Constructs a new instance of PayPal button
    */
  function PayPalButton(props) {
    _classCallCheck(this, PayPalButton);

    var _this = _possibleConstructorReturn(this, (PayPalButton.__proto__ || Object.getPrototypeOf(PayPalButton)).call(this, props));

    _this.state = { toShow: false };
    _this.handlePayment = _this.handlePayment.bind(_this);
    _this.handleAuthorize = _this.handleAuthorize.bind(_this);
    _this.finishPurchase = _this.finishPurchase.bind(_this);
    return _this;
  }

  /** @method handlePayment
    * Called when the PayPal button is clicked.
    */


  _createClass(PayPalButton, [{
    key: 'handlePayment',
    value: function handlePayment(data, actions) {
      var expoName = this.props.expoName;
      var expoID = this.props.expoID;
      var showID = this.props.showID;
      var token = this.props.token || '';

      // Make a call to the REST api to create the payment
      return actions.payment.create({
        payment: {
          transactions: [{
            amount: { total: '15.00', currency: 'USD' },
            // Pass the expoID, showID, and token
            // to identify the transaction on PayPal
            custom: token,
            item_list: {
              items: [{
                name: 'Discount Coupon Package for the ' + expoName,
                price: 15.00,
                currency: 'USD',
                quantity: 1,
                sku: expoID + '/' + showID + '/' + token
              }]
            }
          }]
        }
      });
    }

    /** @method handleAuthorize
      * Called when the PayPal payment is authorized.
      */

  }, {
    key: 'handleAuthorize',
    value: function handleAuthorize(data, actions) {
      // Make a call to the REST api to execute the payment
      return actions.payment.execute().then(this.finishPurchase);
    }

    /** @method finishPurchase
      * Saves the client's purchase to the
      * Vexpo Show Platform.
      * @param {Object} result - the PayPal authorization result
      */

  }, {
    key: 'finishPurchase',
    value: function finishPurchase(result) {
      var _this2 = this;

      var email = result.payer.payer_info.email;
      var expoName = this.props.expoName;
      var expoID = this.props.expoID;
      var showID = this.props.showID;
      var token = this.props.token || '';
      var affiliateName = this.props.affiliateName || '';

      // On successful purchase, launch the purchase function
      // on the firebase server
      var processPurchase = window.vexpo.firebase.functions().httpsCallable('purchaseGiftCards');
      processPurchase({
        url: window.location.protocol + '//' + window.location.host + '/#/lobby',
        show: expoName,
        affiliate: affiliateName,
        email: email,
        expoID: expoID,
        showID: showID,
        token: token,
        transactionID: result.id,
        sku: expoID + '/' + showID + '/' + token
      }).then(function (result) {
        // Use the returned JWT to log the user in
        return window.vexpo.firebase.auth().signInWithCustomToken(result.data);
      }).then(function () {
        // Send the user a login link
        var actionCodeSettings = {
          url: window.location.protocol + '//' + window.location.host + '/#/lobby',
          handleCodeInApp: true
        };
        window.vexpo.firebase.auth().sendSignInLinkToEmail(email, actionCodeSettings).then(function () {
          window.localStorage.setItem('emailForSignIn', email);
        });
        // Once logged in, redirect to lobby
        window.alert("Payment Confirmed your receipt and Fundraiser Discount Coupon Package will be sent to your inbox");
        _this2.setState({ toShow: true });
      }).catch(function (error) {
        // On error, notify the user
        window.alert("There was a problem with your payment.");
        console.error(error);
      });
    }

    /** @method componentDidMount
      * Creates the PayPal button and event listeners
      */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expoName = this.props.expoName;
      var expoID = this.props.expoID;
      var showID = this.props.showID;
      var token = this.props.token;
      var affiliateName = this.props.affiliateName;

      // Render the PayPal button
      paypal.Button.render({
        env: 'production', //'sandbox', // sandbox | production
        // PayPal Client IDs
        client: {
          sandbox: 'Ae02BrnWRBIKHu9LQcar-xmNkaacceacbNnMpbCkAjDrHjX-fCEFFnK_j6lgefDCXmonYbnor7dkmieZ', //'AXLmHYAYKb51CAKfzLDaSXZR5C-z7wS2IJhW5qKBRe0GMVKVm6IU6UFdMv0jIcdqlsUonFFiwYgHH_eX',
          production: 'AYP3LjyZIrptb5z1JUdDB08W1WPRR33VmBIDFU9V1bBsfkc0xb6u1o5iWUME4tUnKE0VElUgyRLR0QjF'
        },
        style: {
          size: this.props.size || 'large'
        },
        // Show the buyer a 'Pay Now' button in the checkout flow
        commit: true,
        // payment() is called when the button is clicked
        payment: this.handlePayment,
        // onAuthorize() is called when the buyer approves the payment
        onAuthorize: this.handleAuthorize
      }, '#paypal-button-container');
    }

    /** @method render
      * Renders the PayPal button component.
      */

  }, {
    key: 'render',
    value: function render() {
      if (this.state.toShow) return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/lobby' });else return _react2.default.createElement('div', { id: 'paypal-button-container' });
    }
  }]);

  return PayPalButton;
}(_react.Component);

exports.default = PayPalButton;


PayPalButton.propTypes = {
  expoName: _propTypes2.default.string.isRequired,
  expoID: _propTypes2.default.string.isRequired,
  showID: _propTypes2.default.string.isRequired,
  affiliateName: _propTypes2.default.string,
  token: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/paypal-button/paypal-button.js
// module id = 260
// module chunks = 0